import { cookieManager } from "@/service/cookieManager";
/* ------------------------------- helper -------------------------------- */
export async function apiRequest(opts) {
    const { url, method = 'GET', body = null, token = cookieManager.getToken(), // your existing helper
    headers = {}, expect = 'json', throwOnNonOk = true, } = opts;
    /* ---------- build request ---------- */
    const finalHeaders = {
        Accept: 'application/json',
        ...headers,
    };
    // Set Content-Type for POST/PUT/PATCH requests, even with empty body
    if (['POST', 'PUT', 'PATCH'].includes(method) && body !== null && !(body instanceof FormData)) {
        // PATCH needs merge-patch, everything else can be application/json
        finalHeaders['Content-Type'] =
            method === 'PATCH'
                ? 'application/merge-patch+json'
                : 'application/json';
    }
    else if (['POST', 'PUT', 'PATCH'].includes(method) && body === null) {
        // For POST/PUT/PATCH with null body, still set Content-Type
        finalHeaders['Content-Type'] =
            method === 'PATCH'
                ? 'application/merge-patch+json'
                : 'application/json';
    }
    if (token) {
        finalHeaders['Authorization'] = `Bearer ${token}`;
    }
    const absoluteUrl = new URL(url, window.location.origin).toString();
    /* ---------- execute ---------- */
    let response;
    try {
        response = await fetch(absoluteUrl, {
            method,
            headers: finalHeaders,
            ...(body && !(body instanceof FormData)
                ? { body: JSON.stringify(body) }
                : body instanceof FormData
                    ? { body }
                    : (['POST', 'PUT', 'PATCH'].includes(method) && body === null)
                        ? { body: '{}' } // Send empty JSON object for null body
                        : {}),
        });
    }
    catch (networkErr) {
        // re-throw in a predictable shape
        throw new Error(`Network error: ${String(networkErr)}`);
    }
    /* ---------- handle status codes ---------- */
    if (throwOnNonOk && !response.ok) {
        const errText = await response.text().catch(() => '');
        throw new Error(`HTTP ${response.status}: ${errText}`);
    }
    /* ---------- parse payload according to "expect" ---------- */
    let data = null;
    if (response.status !== 204 && method !== 'HEAD') {
        const contentType = response.headers.get('content-type') ?? '';
        switch (expect) {
            case 'blob':
                data = await response.blob();
                break;
            case 'text':
                data = await response.text();
                break;
            case 'void':
                data = null;
                break;
            default: // 'json'
                if (!contentType.includes('application/json')) {
                    throw new Error(`apiRequest: Expected JSON but got ${contentType || 'no content-type'}`);
                }
                data = await response.json();
        }
    }
    return {
        ok: response.ok,
        status: response.status,
        headers: response.headers,
        data,
    };
}
